/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PoLanguage } from '@po-ui/ng-components';
import {
  PoPageLoginCustomField,
  PoPageLoginLiterals
} from '@po-ui/ng-templates';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { BaseLoginComponent } from 'src/app/shared/component/base/base-login-component';
import { environment } from 'src/environments/environment';
import { User } from './shared/user';
import { ParameterService } from 'src/app/shared/services/parameters.service';

@Component({
  selector: 'tgv-login',
  standalone: false,
  templateUrl: './login.component.html'
})
export class LoginComponent extends BaseLoginComponent implements OnInit {
  customField: PoPageLoginCustomField;
  errorMessage: string[] = [];
  customLiterals: PoPageLoginLiterals;
  isLoading = false;
  pgvVersion = environment.pgvVersion;

  constructor(
    private router: Router,
    protected injetor: Injector,
    private parameterService: ParameterService
  ) {
    super(injetor);
  }

  ngOnInit(): void {
    this.setCustomFields();
    this.setCustomLiterals();
    this.onInitCheckErrors();
  }

  onInitCheckErrors(): void {
    if (this.parameterService.isError) {
      this.router.navigate(['incorrect-configuration'], { queryParams: { id: 'backend-updated-pgv' } });
    }
  }

  setCustomLiterals(): void {
    this.customLiterals = {
      loginPlaceholder: this.literals.str0487,
      passwordPlaceholder: this.literals.str0488
    };
  }

  setCustomFields(): void {
    this.customField = this.getCustomFields();
  }

  getCustomFields(): PoPageLoginCustomField {
    return {
      property: 'alias',
      placeholder: this.literals.str0030
    };
  }

  onLogin(event): void {
    this.isLoading = true;
    this.errorMessage = [];
    this.onUserAuth(event);
  }

  setLoggedUserToStorageAndLogin(user: User): void {
    localStorage.setItem('user', user.login);
    this.router.navigate(['carga']);
  }

  handleChangeLanguage(event: PoLanguage): void {
    this.setLiterals(event.language);
  }

  setLiterals(language: string): void {
    this.literalsService
      .getLiterals(language)
      .subscribe((literals: LiteralsWords) => {
        this.literals = literals;
        this.literalsService.literals = literals;
        localStorage.setItem(
          'PO_DEFAULT_LANGUAGE',
          this.literalsService.languegeToString(language)
        );
        this.setCustomFields();
        this.setCustomLiterals();
      });
  }

  setCancelLoading(): void {
    this.isLoading = false;
  }

  get secondaryLogo(): string {
    return this.deviceService.returnSmartphone() ? '' : '../../../../assets/icons/logo_totvs.png';
  }
}
